"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "e209404",
    "raw": "v3.29.0",
    "semverString": "3.29.0"
};
//# sourceMappingURL=version.js.map